const createContext = window.wp.element.createContext;
const Context = createContext();

export default Context;
